import { Component } from "@angular/core";
import {
    NavController,
    NavParams,
    ViewController,
    ToastController
} from "ionic-angular";
import { APIServiceProvider } from "../../common/services/api.service";
import { HelperServiceProvider } from "./../../common/services/helper.service";
import { NotifyService } from "../../services/notify.service";

@Component({
    selector: "modal-submitcash",
    templateUrl: "./submitcash.html"
})
export class SubmitCashModalPage {
    public orderDetails = null;
    public orderData = {
        payment_date: new Date().toISOString(),
        payment_type: "cash",
        comments: null,
        amount: 0,
        order_id: null,
        to_user_id: null
    };

    public submitDisabled = false;

    public cashHierarchy = null;

    constructor(
        public navCtrl: NavController,
        public viewCtrl: ViewController,
        public navParams: NavParams,
        private apiHelper: APIServiceProvider,
        public toastCtrl: ToastController,
        public helperService: HelperServiceProvider,
        private notifyService: NotifyService
    ) {
        this.getCashHieararchy();
        this.orderDetails = this.navParams.get("orderDetails");
        this.orderData["order_id"] = this.orderDetails["order_id"];
        this.orderData["amount"] = this.orderDetails["amount"];
    }

    dismiss() {
        this.viewCtrl.dismiss();
    }

    ionViewWillLeave() {
        let backDrop: any = document.getElementsByTagName("datetime_input");
        if (backDrop.length > 0) {
            for (let i = 0; i < backDrop.length; i++) {
                backDrop[i].style.display = "none";
            }
        }
    }

    submitCash() {
        if (this.orderData["to_user_id"] === null) {
            this.helperService.presentToast("Select a manager");
            return;
        }
        this.submitDisabled = true;
        this.apiHelper.post("orders/submit-cash", this.orderData).subscribe(
            result => {
                this.submitDisabled = false;
                this.helperService.presentToast("Success");
                this.notifyService.CashSubmitted(true);
                this.viewCtrl.dismiss();
            },
            err => {
                this.helperService.presentToast(
                    "Some error occurred, please try again later"
                );
                this.submitDisabled = false;
                this.viewCtrl.dismiss();
            }
        );
    }

    getCashHieararchy() {
        this.apiHelper
            .post("orders/cash-hierarchy", { relation: "managers" })
            .subscribe(result => {
                this.cashHierarchy = result["data"];
            });
    }
}



// WEBPACK FOOTER //
// ./src/modals/submitcash/submitcash.ts